var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isEngineer || _vm.isTenant,
          expression: "isEngineer || isTenant",
        },
      ],
      staticClass: "my-tenant-projects dashboard",
    },
    [
      _vm.isTenant && _vm.loading
        ? _c("h6", { staticClass: "font-dark-gray" }, [
            _c("i", { staticClass: "rotation fa fa-refresh" }),
            _vm._v("\n    " + _vm._s(_vm.$t("loading")) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.isEngineer ||
                (_vm.projectData && _vm.projectData.length > 0),
              expression: "isEngineer || projectData && projectData.length > 0",
            },
          ],
        },
        [
          _c(
            "div",
            {
              class: [
                "tms-dashboard__panel-header row",
                !_vm.isEngineer ? "no-margin-bottom" : "",
              ],
            },
            [
              _c(
                "div",
                {
                  staticClass: "tms-dashboard__panel-container-without-button",
                },
                [
                  _c("div", { staticClass: "tms-dashboard__panel-title-box" }, [
                    _c(
                      "div",
                      {
                        class: [
                          "dashboard__title",
                          _vm.isEngineer ? "no-margin-bottom" : "",
                        ],
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t("tender.general.fitoutAndReinstatement")
                            ) +
                            "\n            "
                        ),
                        _vm.isEngineer
                          ? _c("i", {
                              staticClass:
                                "fa fa-refresh dark flat icon_refresh",
                              attrs: { id: "dashboard_refresh" },
                              on: {
                                click: function ($event) {
                                  return _vm.loadTenantProject()
                                },
                              },
                            })
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.isEngineer
                      ? _c(
                          "div",
                          { staticClass: "tms-dashboard__panel-view-all" },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: "/tenant-projects" } },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("viewAll")) +
                                    " >\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _vm.isEngineer
                    ? _c(
                        "div",
                        { staticClass: "tms-dashboard__panel-toolbar" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "handover-takeback__counter--duration tms-dashboard__panel-toolbar-right",
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("showLabel")) + ":"),
                              ]),
                              _vm._v(" "),
                              _c("HKLSelect", {
                                attrs: {
                                  options: _vm.timeHklOptions,
                                  showSearch: false,
                                  value: _vm.selectedTimeValue,
                                },
                                on: { change: _vm.selectStatusDate },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _vm.isEngineer
                ? _c("HKLButton", {
                    staticClass: "tms-dashboard__panel-reset-btn",
                    attrs: { color: "darkblue", action: "resetFilter" },
                    on: { click: _vm.resetFilter },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "dashboard__body" }, [
            _c("div", { staticClass: "dashboard__table" }, [
              _c("table", { staticClass: "sort_table" }, [
                _c("thead", { staticClass: "table-header-title" }, [
                  _c(
                    "tr",
                    { staticClass: "dashboard__table--header" },
                    _vm._l(_vm.tableHeaders, function (header) {
                      return _c(
                        "th",
                        {
                          key: header.name,
                          class: header.name,
                          on: {
                            click: function ($event) {
                              return _vm.sortBy(header.name)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "emphasis" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(header.title) +
                                "\n                  "
                            ),
                            _vm.orderbyAttr === header.name
                              ? _c("i", {
                                  class: [
                                    _vm.reverse
                                      ? "triangle-down"
                                      : "triangle-up",
                                  ],
                                })
                              : _vm._e(),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.isHKlandUser
                    ? _c(
                        "tr",
                        { staticClass: "table-filter" },
                        _vm._l(_vm.tableHeaders, function (header) {
                          return _c(
                            "th",
                            { key: header.name, class: header.name },
                            [
                              _c(
                                "div",
                                { staticClass: "table-filter-container" },
                                [
                                  header.filter
                                    ? _c(
                                        header.filter,
                                        _vm._b(
                                          {
                                            tag: "component",
                                            model: {
                                              value:
                                                _vm.filterObject[header.name],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.filterObject,
                                                  header.name,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "filterObject[header.name]",
                                            },
                                          },
                                          "component",
                                          header.filterAttrs || {},
                                          false
                                        )
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  { staticClass: "table-content" },
                  _vm._l(_vm.filteredItems, function (item, index) {
                    return _c(
                      "tr",
                      { key: index, staticClass: "dashboard__table--body" },
                      _vm._l(_vm.tableHeaders, function (header) {
                        return _c(
                          "td",
                          { key: header.name },
                          [
                            header.name === "projectLocation"
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "link_text project-location",
                                    on: {
                                      click: function ($event) {
                                        return _vm.jumpAfterSettingTabIndex({
                                          name: _vm.tenantProjectRouteName,
                                          params: { id: item.id },
                                        })
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          item[header.name] || _vm.emptyValue
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                )
                              : header.name === "batchStatus"
                              ? [
                                  !item[header.name] &&
                                  !item.postFitoutBatchStatus &&
                                  !item.greenFitOutBatchStatus
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "link_text",
                                          on: {
                                            click: function ($event) {
                                              return _vm.navigateBatchStatus(
                                                item,
                                                "1"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.emptyValue +
                                                  "/" +
                                                  _vm.emptyValue
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", [
                                    item[header.name]
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "link_text",
                                            on: {
                                              click: function ($event) {
                                                return _vm.navigateBatchStatus(
                                                  item,
                                                  "1"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(item[header.name]) +
                                                "\n                    "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    item.postFitoutBatchStatus
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "link_text",
                                            on: {
                                              click: function ($event) {
                                                return _vm.navigateBatchStatus(
                                                  item,
                                                  "2"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  item.postFitoutBatchStatus
                                                ) +
                                                "\n                    "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    item.greenFitOutBatchStatus
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "link_text",
                                            on: {
                                              click: function ($event) {
                                                return _vm.navigateBatchStatus(
                                                  item,
                                                  "3"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  item.greenFitOutBatchStatus
                                                ) +
                                                "\n                    "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  item.isNewDoc && _vm.isEngineer
                                    ? _c("div", { staticClass: "new-doc" }, [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.$t("tenantProjects.docs")
                                            ) +
                                            "\n                  "
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              : header.name === "tradeStatus" && _vm.isEngineer
                              ? _c("div", [
                                  _c(
                                    "div",
                                    { staticClass: "pin-placeholder" },
                                    [
                                      item.isShowDot
                                        ? _c("div", {
                                            staticClass: "pin__dot-green",
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.isShowPin
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "pin__bubble-orange",
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-thumb-tack",
                                                attrs: {
                                                  "aria-hidden": "true",
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ])
                              : header.name === "tradeName" && _vm.isEngineer
                              ? _c(
                                  "div",
                                  { staticClass: "trade-name__display" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          item[header.name] || _vm.emptyValue
                                        )
                                      ),
                                    ]),
                                  ]
                                )
                              : header.name === "date"
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.dateUtil.formatDate(item[header.name])
                                    )
                                  ),
                                ])
                              : header.name === "projectType"
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("customTProjectTypeLabel")(
                                        item[header.name] || _vm.emptyValue
                                      )
                                    )
                                  ),
                                ])
                              : header.name === "status"
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("customStatusLabel")(
                                        item[header.name] || _vm.emptyValue
                                      )
                                    )
                                  ),
                                ])
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(item[header.name] || _vm.emptyValue)
                                  ),
                                ]),
                          ],
                          2
                        )
                      }),
                      0
                    )
                  }),
                  0
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }